import { styled } from 'linaria/react';
import { css } from 'linaria';

export const GalleryImageWrapper = styled.button`
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: var(--rounding-m);
  cursor: pointer;
`;

export const inspirationGalleryTitle = css`
  && {
    margin-bottom: 8px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const inspirationGalleryDescription = css`
  margin-bottom: 24px;

  @media (--only-mobile) {
    display: none;
  }
`;

export const gridGallery = css`
  && {
    & .swiper-wrapper {
      display: grid;
      grid-template-columns: 248px 435px 453px;
      grid-template-rows: 283px 233px;
      row-gap: 20px;
      column-gap: 22px;

      & .swiper-slide:nth-of-type(1) {
        grid-column-start: span 2;
      }

      & .swiper-slide:nth-of-type(2) {
        grid-row-start: span 2;
      }

      @media (--only-desktop) {
        grid-template-columns: 199px 347px 362px;
        grid-template-rows: 226px 186px;
        row-gap: 16px;
        column-gap: 16px;
      }

      @media (--only-tablet) {
        grid-template-columns: 139px 243px 254px;
        grid-template-rows: 215px 130px;
        row-gap: 12px;
        column-gap: 12px;
      }

      @media (--only-mobile) {
        display: flex;
        column-gap: 0;
        row-gap: 0;
      }
    }
  }
`;

export const gridGalleryImage = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--rounding-m);
`;

export const gridGallerySlide = css`
  @media (--only-mobile) {
    width: 256px;
    height: 228px;
    border-radius: var(--rounding-m);

    &:not(:last-of-type) {
      margin-right: 18px;
    }
  }
`;
